import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'cliente-list',
	templateUrl: './cajero-asignar-list.component.html',
	styleUrls: ['./cajero-asignar-list.component.css'],
})
export class CajeroAsignarListComponent implements OnInit {
	public dataGrid: any;

	constructor() {
		this.dataGrid = {
			keyGrid: "cc",
			perPage: 10,
            endPoint: "/cajero/caja",
            hideActionButtons: true,
            qs: "&embed=cajero?embed=sucursal,caja",
			columsDef: [
				{
					Header: "Sucursal",
					Field: "cajero.sucursal.nombre"
				},
				{
					Header: "Caja",
					Field: "caja.nombre"
				},
				{
					Header: "Establecimiento",
					Field: "cajero.sucursal.establecimiento"
				},
				{
					Header: "Punto de emisión",
					Field: "caja.punto_emision"
				},
				{
					Header: "Cajero",
					Field: "cajero.usuario"
				}
			]
		};
	}

	ngOnInit() {
		//
	}
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/cajero-asignar-list/cajero-asignar-list.component.ts